import { userConstants } from "../_constants";
import { userService } from "../_services";
import { hashHistory } from "../_helpers";

export const userActions = {
  login,
  logout,
};

function login(username, password, route = null) {
  if (route == null) route = "/dashboard";
  return (dispatch) => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      (response) => {
        if (response.access_token) {
          dispatch(success(response.user, response.webUser));
          hashHistory.push(route);
        } else {
          dispatch(failure("Unable to authenticate"));
        }
      },
      (error) => {
        console.warn(error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user, webUser) {
    return { type: userConstants.LOGIN_SUCCESS, user, webUser };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}
